import React from 'react';
import { useTranslation } from 'react-i18next';
import EditorSaveStatus from 'components/EditorSaveStatus';
import TextLink from 'components/TextLink';
import Card from 'components/Card';
import StickyBox from 'components/StickyBox';
import { jsx as _jsx } from "react/jsx-runtime";
export function EditorPageStickySaveDiscardButton(_ref) {
  var hasChanges = _ref.hasChanges,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    isSaving = _ref.isSaving,
    tooltipTitle = _ref.tooltipTitle,
    buttonText = _ref.buttonText,
    cardVariant = _ref.cardVariant,
    onSave = _ref.onSave,
    onDiscard = _ref.onDiscard;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var tooltip = tooltipTitle || t('actions_resolve_errors_to_save');
  return /*#__PURE__*/_jsx(StickyBox, {
    placement: "bottom",
    borderRadius: "large",
    mt: "m",
    children: /*#__PURE__*/_jsx(Card, {
      px: "m",
      py: "s",
      variant: cardVariant,
      children: /*#__PURE__*/_jsx(EditorSaveStatus, {
        stateOptions: hasChanges && /*#__PURE__*/_jsx(TextLink, {
          as: "button",
          onClick: onDiscard,
          isDisabled: isSaving,
          children: t('actions_discard')
        }),
        hasUnsavedChanges: hasChanges,
        onSave: onSave,
        isDisabled: isDisabled,
        isSaving: isSaving,
        buttonText: buttonText,
        tooltipTitle: isDisabled ? tooltip : undefined,
        justifyContent: ['space-between', 'space-evenly'],
        breakpoints: "xxs"
      })
    })
  });
}
export default EditorPageStickySaveDiscardButton;